import PageIndicator from "components/PageIndicator";
import $ from 'jquery';
import { useState } from "react";
import { Icon } from "semantic-ui-react";

const ContentCarousel = ({
  darkOnLight = false,
  showInstagramLink = true,
  showAllOnDesktop = true,
  scrollUsingDots = false,
  children,
  containerClassName,
  contentCarouselClassName,
  pageIndicatorContainerClassName,
  style,
}) => {
  const [page, setPage] = useState(0);

  let contentCarousel, scrollWidth;

  const scrollCarousel = (dx) => {
    if (typeof window !== 'undefined') {
      $('.contentCarousel').animate({ scrollLeft: dx }, 300);
    }
  };

  return (
    <div className={containerClassName} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ...style }}>
      <div
        className={`contentCarousel ${contentCarouselClassName}`}
        onScroll={() => {
          if (typeof contentCarousel === 'undefined') {
            contentCarousel = $('.contentCarousel');
            scrollWidth = contentCarousel[0].scrollWidth - contentCarousel.width();
          }

          setPage(Math.round(contentCarousel.scrollLeft() * (children.length - 1) / scrollWidth));
        }}>
        { children }
      </div>

      <div className={`pageIndicatorContainer ${pageIndicatorContainerClassName}`}>
        <PageIndicator
          darkOnLight={darkOnLight}
          currentPageIndex={page}
          pageCount={children.length}
          onDotClick={(newPage) => {
            if (scrollUsingDots) {
              const oldPage = page;
              contentCarousel = $('.contentCarousel');
              scrollWidth = contentCarousel[0].scrollWidth / children.length;
              scrollCarousel(scrollWidth * (page + newPage - oldPage));
            }
          }}
        />
      </div>

      { showInstagramLink &&
        <a href="https://www.instagram.com/daymadeuk/" target="_blank" style={{ margin: '0.5em 0 0 0', verticalAlign: 'middle' }}>
          <Icon name={'instagram'} style={{ fontSize: '1.5em', display: 'inline-flex', verticalAlign: 'middle', height: 'auto' }} />
          @daymadeuk
        </a>
      }

      <style jsx>{`
        .contentCarousel {
          padding: 1em;
          display: flex;
          width: 100%;
          max-width: 1000px;
          overflow-x: auto;
          height: auto;
        }
        
        .contentCarousel::-webkit-scrollbar {
          display: none;
        }
        
        a {
          display: flex;
          align-items: center;
          font-weight: bold;
          margin: 0 0 10px 0;
          color: #BABABA;
        }
        
        a:hover {
          color: #FFF;
        }
        
        :global(.socialMediaIcon) {
          margin-right: 15px;
        }
        
        @media(min-width: 800px) {
          .contentCarousel {
            ${showAllOnDesktop && 'overflow-x: visible;'}
            ${showAllOnDesktop && 'justify-content: center;'}
          }
          
          .pageIndicatorContainer {
            ${showAllOnDesktop && 'display: none;'}
          }
        }
      `}</style>
    </div>
  );
};

export default ContentCarousel;
